import req from './../../fetch';
import { undocumentedResponse } from './../../utils';
import { PostPayload } from '.';
import { AllAPIResponses, CarbonError, RuleType } from './../../index';

const post = async (
  payload: PostPayload,
  headers?: Headers
): Promise<AllAPIResponses<RuleType>> => {
  try {
    const resp = await req.post('/api/rules', JSON.stringify(payload), headers);
    const clone = resp.clone();
    switch (resp.status) {
      case 201:
        return {
          data: (await resp.json()) as RuleType,
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default post;
